export default __webpack_public_path__ + "static/media/Fees.efada0f0.svg";